// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VUCQTkTFhnMvym .board-canvas:last-child,
.VUCQTkTFhnMvym .plugin-board-bar {
  margin-bottom: 62px;
  transition: margin 0.2s ease-in-out;
}
.VUCQTkTFhnMvym .board-canvas:has(#board) {
  margin-bottom: var(--ds-space-0, 0);
}
.mbL3M7zH1awPW1 .board-canvas:last-child,
.mbL3M7zH1awPW1 .plugin-board-bar {
  margin-bottom: 26px;
}
`, ""]);
// Exports
export var boardPanelPadding = `VUCQTkTFhnMvym`;
export var multiplePanelPadding = `mbL3M7zH1awPW1`;
export default ___CSS_LOADER_EXPORT___;
